import script from "./HomepageGroupsFilterLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageGroupsFilterLoader.vue?vue&type=script&setup=true&lang=js"

import "./HomepageGroupsFilterLoader.vue?vue&type=style&index=0&id=c9c0c92e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9c0c92e"]])

export default __exports__